/**
 * Раскрытие строки-возражения в «Что изменилось» «Голоса клиента» (#2552):
 * тот же код, что в разделе «Возражения», — формулировки, цитаты клиента с
 * подсветкой в стенограмме, лучшие отработки, этапы. Не список «последних
 * разговоров»: цитаты кода — выборка, а не все его разговоры.
 */
import type { ObjectionStreamCode } from '@aica/api-types/schemas';
import { useOpenRecord } from '@/components/dashboards/shared/highlights/useOpenRecord';
import type { VoiceRowDetailsTrend } from '../voice/voice-series-view-model';
import { ObjectionCodeDetails } from './ObjectionCodeDetails';

interface VoiceObjectionRowDetailsProps {
  id: string;
  code: ObjectionStreamCode;
  /** The row's series: a chart whose bucket narrows the quotes. */
  trend?: VoiceRowDetailsTrend;
}

export function VoiceObjectionRowDetails({
  id,
  code,
  trend,
}: VoiceObjectionRowDetailsProps) {
  const openRecord = useOpenRecord();
  return (
    <ObjectionCodeDetails
      id={id}
      code={code}
      mode="market"
      series={trend}
      onOpenCall={(recordId, quote) => openRecord(recordId, { quote })}
    />
  );
}
